export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5242.0c380601.jpg";